<template>
    <div class="row container--stretch">
        <!-- LEFT SIDE -->
        <div class="col-md-2 hidden-sm hidden-xs no-padder left bg-grey">
            <div class="container-fluid p-y">
                
            </div>
        </div>
        <div class="col-md-8 no-padder">				
            <div class="container-fluid p-y">
                Careers page
            </div>
        </div>
        <div class="col-md-2 hidden-sm hidden-xs right">
            <div class="container-fluid p-y">
                
            </div>
        </div>
    </div>
</template>

<script>
export default {
}
</script>
